import { z } from 'zod'

/**
 * What a connected assistant is allowed to do.
 *
 * Read and write cover the book of business. Sending mail, changing the
 * business, and inviting someone are separate because a person can want an
 * assistant to look things up without letting it email a client.
 */
export const OAUTH_SCOPES = [
  'records:read',
  'records:write',
  'proposals:send',
  'organization:write',
  'team:manage',
] as const

export const oauthScopeSchema = z.enum(OAUTH_SCOPES)

export type OauthScope = z.infer<typeof oauthScopeSchema>

/** Sentences on the connect screen. The scope string itself is not shown. */
export const OAUTH_SCOPE_LABELS: Record<OauthScope, string> = {
  'records:read': 'See clients, sites, trees, photos, videos, and proposals.',
  'records:write':
    'Add and edit those records. Photos and videos are added in Smithwell. A place you did not capture yourself is saved only after you say it looks right on a map.',
  'proposals:send':
    'Email a proposal, mark it sent, and record what the customer decided.',
  'organization:write': 'Change rates, tax, wording, catalogs, and the logo.',
  'team:manage': 'Invite a teammate or cancel an invitation.',
}

/**
 * These start unchecked even when the assistant asked for them.
 * Read and write start checked when they were requested.
 */
export const OAUTH_SCOPES_START_UNCHECKED: readonly OauthScope[] = [
  'proposals:send',
  'organization:write',
  'team:manage',
]
